module.exports = __webpack_public_path__ + "img/코엑스 한우.f24fd715.png";